/**
 * Permission helpers shared across roles.
 *
 * - `hasWarehousePowers(user)`: true se l'utente può gestire magazzino,
 *   picking, giri consegne, status ordini "warehouse-side". Vero per:
 *   • role === "magazziniere"
 *   • role === "admin"
 *   • role === "agent" con flag `magazziniere_extra` attivo
 */
export function hasWarehousePowers(user) {
  if (!user) return false;
  if (user.role === "magazziniere" || user.role === "admin") return true;
  if (user.role === "agent" && user.magazziniere_extra) return true;
  return false;
}

/**
 * `isWarehouseView(user)`: come sopra ma escludendo gli admin (che hanno
 * una propria dashboard). Usato per decidere se il layout è quello del
 * magazzino (header, redirect, etc.).
 */
export function isWarehouseView(user) {
  if (!user) return false;
  if (user.role === "magazziniere") return true;
  if (user.role === "agent" && user.magazziniere_extra) return true;
  return false;
}
